import React from 'react';

import SirenSCIs from '../../components/Monitoring/SCIs/SirenSCIs';



function SirenSCIsView() {
  return (
    <SirenSCIs />
  );
}

export default SirenSCIsView;
